import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        url: '='
    },
    template: `
        <div class="iframe-wrapper" style="height: 100%">
            <iframe id="ifr"
            ng-src="{{ vm.url }}" width="100%" height="100%" frameborder="0" scrolling="no"></iframe>
        </div>
    `
})
export default class {
    constructor ($, MaterialService, TokenService, $translate) {
        this.$ = $;
        this.url = MaterialService.getTokenizedUrl(this.url, TokenService.token);
        this.$translate = $translate;
    }

    $onInit () {
        const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        const eventer = window[eventMethod];
        const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
        const loadingMsg = this.$translate.instant('general.Loading');

        const iframeWrapper = document.querySelector('.iframe-wrapper');
        const iframe = iframeWrapper.querySelector('iframe');
        iframe.srcdoc = `<!DOCTYPE html><BODY><p style="font-family: Poppins,Arial,Helvetica,sans-serif;">${loadingMsg}...</p></BODY>`;
        iframe.addEventListener('load', () => {
            iframe.removeAttribute('srcdoc');

            try {
                const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

                const injectStylesIntoNested = () => {
                    const nestedIframe = iframeDoc.querySelector('iframe');

                    if (!nestedIframe) {
                        return false;
                    }

                    const tryInject = () => {
                        try {
                            const nestedDoc = nestedIframe.contentDocument || nestedIframe.contentWindow.document;

                            if (!nestedDoc || nestedDoc.readyState !== 'complete') {
                                return false;
                            }

                            const style = nestedDoc.createElement('style');
                            style.textContent = `
                                .h5p-confirmation-dialog-background {
                                    display: flex;
                                    place-content: center;
                                }
                                .h5p-confirmation-dialog-popup {
                                    position: initial;
                                    transform: none;
                                    -webkit-transform: none;
                                }
                            `;
                            nestedDoc.head.appendChild(style);
                            return true;
                        }
                        catch (e) {
                            console.warn('Cannot access nested iframe:', e);
                            return false;
                        }
                    };

                    if (tryInject()) {
                        return true;
                    }

                    nestedIframe.addEventListener('load', () => {
                        tryInject();
                    });

                    return true;
                };

                if (!injectStylesIntoNested()) {
                    const observer = new MutationObserver(() => {
                        if (injectStylesIntoNested()) {
                            observer.disconnect();
                        }
                    });
                    observer.observe(iframeDoc.body, { childList: true, subtree: true });
                }
            }
            catch (e) {
                console.warn('Cannot inject styles into cross-origin iframe', e);
            }
        });

        eventer(messageEvent, (e) => {
            this.$('#ifr').css('height', `${e.data}px`);
        }, false);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/materials/iframe/index.js